<span class="font-semibold"
      [class.positiveAmount]="amount() >= 0"
      [class.negativeAmount]="amount() < 0"
>{{ amount() | showSignValueType: 'Monetary' }}</span>
